import React from 'react'

type Props = {
  questionnaire: Record<string, string>
}

export const FormattedQuestionnaire = ({ questionnaire }: Props) => {
  const questionsArray = Object.keys(questionnaire).filter((question) => question !== '__typename')

  if (!questionsArray.length) {
    return null
  }

  return (
    <div>
      {questionsArray.map((question) => {
        return (
          <div key={question}>
            <b>{question}</b>: {questionnaire[question]}
          </div>
        )
      })}
    </div>
  )
}
